import React from 'react';
import styles from './AddIpo.module.css';

/**
 * Logo picker used by all four Investment Services forms.
 *
 * The path can still be typed or pasted, but the Upload button posts the file
 * through the same /upload-media endpoint the proposal files use and drops the
 * returned path into the field, so nobody has to know the URL format.
 */
const LogoField = ({ value, onChange, error, uploading, onUpload, previewUrl }) => (
  <div className={styles.formGroup}>
    <label className={styles.label}>Logo</label>

    <div className={styles.logoRow}>
      {value ? (
        <img
          src={previewUrl}
          alt="Logo preview"
          className={styles.logoPreview}
          onError={(e) => { e.target.style.visibility = 'hidden'; }}
        />
      ) : (
        <div className={styles.logoPlaceholder}>Logo</div>
      )}

      <input
        type="text"
        name="logo"
        value={value ?? ''}
        onChange={onChange}
        placeholder="Upload an image, or paste a path"
        className={`${styles.input} ${error ? styles.inputError : ''}`}
      />

      <label className={`${styles.uploadBtn} ${uploading ? styles.uploadBtnDisabled : ''}`}>
        {uploading ? 'Uploading…' : 'Upload'}
        <input
          type="file"
          accept="image/png,image/jpeg,image/webp,image/gif"
          onChange={onUpload}
          disabled={uploading}
          hidden
        />
      </label>
    </div>

    {error ? <span className={styles.fieldError}>{error}</span> : null}
  </div>
);

export default LogoField;
